import config from '@/config'
import router from '@/router'
import store from '@/store'
import lodash from 'lodash'

function getMode () {
  let result = ''
  let path = router.app._route.path
  let cdu = path.indexOf('/cdu') > -1
  let carousel = path.indexOf('/carousel') > -1

  if (cdu) result = 'CDU'
  if (carousel) result = 'CAROUSEL'

  return result
}

function getBrand () {
  var brands = config.app.brands
  var urlBrand = router.app._route.params.client || config.app.brands.default
  var result = config.app.brands.default

  urlBrand = urlBrand.toLowerCase()

  lodash.forOwn(brands, function (value, key) {
    if (value === urlBrand) {
      result = value
      return false
    }
  })

  return result
}

function getScreenId () {
  return (router.app._route.params.screenid || 'SCREEN1').toUpperCase()
}

function getTemplate () {
  return router.app._route.params.displaytemplate || 'standard'
}

function getBig3Columns () {
  var parambig3columnsorder = router.app._route.params.big3columnsorder || '321'
  var appConfig = store.getters['cduState/getAppConfigForBrand'] || {}
  let urlParamToBig3MarketMap = appConfig.urlParamToBig3MarketMap

  var arrColumns = []
  parambig3columnsorder.split('').forEach((p, index) => {
    arrColumns.push(urlParamToBig3MarketMap[parambig3columnsorder[index]])
  })

  return arrColumns
}

export default {
  getMode,
  getBrand,
  getScreenId,
  getTemplate,
  getBig3Columns
}



// WEBPACK FOOTER //
// ./src/library/cdu/urlParameters.js